import { render, staticRenderFns } from "./FavoriteProperty.vue?vue&type=template&id=3bd6fdd1&"
import script from "./FavoriteProperty.vue?vue&type=script&lang=js&"
export * from "./FavoriteProperty.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteProperty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports